import { jsx as _jsx } from "react/jsx-runtime";
import scss from './CommonContainer.module.scss';
export const CommonContainer = ({ className = '', children }) => (_jsx("div", Object.assign({ className: `${scss.commonContainer} ${className}` }, { children: children })));
